<template><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.5 3.69189H0.5V15.6919H12.5V9.72217" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.5 12.707L15.5 0.707031" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.5 0.707031H15.5V6.70703" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round"/>
</svg></template><script>export default {}</script>
